import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import classes from '@nerdwallet/base-styles/classes';
import { ElementImpression } from '@nerdwallet/nw-client-lib/tracking';
import Type, { Text, Heading } from '@nerdwallet/react-typography';
import { Impression as BedrockImpression } from '@nerdwallet/analytics/react/impression';

const CCBest = ({ eyebrow, heading, links, linksMobile }) => {
  const getLinksHTML = () => ({ __html: links });
  const getLinksMobileHTML = () => ({ __html: linksMobile });

  return (
    <BedrockImpression entityName="best_card_category_tool">
      <ElementImpression
        elementDomType="section"
        elementName="CCBest"
        id="best-cards-tool"
      >
        <section
          className={classNames([
            'cc-best__section',
            classes('margin-horizontal-3'),
            classes('margin-bottom-5'),
            classes('margin-horizontal-auto--wide'),
            classes('padding-horizontal-4--wide'),
          ])}
        >
          <div
            className={classNames([
              'cc-best__content',
              classes('border-neutral-lighter'),
              classes('border-all-1'),
              classes('padding-vertical-4'),
              classes('padding-horizontal-4'),
              classes('display-flex'),
              classes('flex-direction-column'),
              classes('flex-direction-row--wide'),
            ])}
          >
            <div
              className={classNames([
                'cc-best-section__text',
                classes('margin-horizontal-auto'),
                classes('text-align-center'),
                classes('width-100'),
              ])}
            >
              <Text
                color="neutral-darker"
                uppercase
                small
                bold
                className={classNames([
                  'cc-best-section__eyebrow',
                  classes('margin-bottom-3'),
                ])}
              >
                {eyebrow}
              </Text>
              <Heading
                level={4}
                bold
                className={classNames([
                  'cc-best-section__heading',
                  classes('margin-bottom-3'),
                ])}
              >
                {heading}
              </Heading>
              <div>
                <Type
                  size="2"
                  className={classNames([
                    'cc-best-section__links',
                    classes('display-none'),
                    classes('display-block--wide'),
                  ])}
                  dangerouslySetInnerHTML={getLinksHTML()}
                />
                <Type
                  size="2"
                  className={classNames([
                    'cc-best-section__linksMobile',
                    classes('display-block'),
                    classes('display-none--wide'),
                  ])}
                  dangerouslySetInnerHTML={getLinksMobileHTML()}
                />
              </div>
            </div>
          </div>
        </section>
      </ElementImpression>
    </BedrockImpression>
  );
};

CCBest.propTypes = {
  eyebrow: PropTypes.string,
  heading: PropTypes.string,
  links: PropTypes.string,
  linksMobile: PropTypes.node,
};

CCBest.displayName = 'CCBest';

export default CCBest;
